export default "__VITE_ASSET__Bqen$k5M__"